<template>
  <div>
    <h1 class="text-capitalize text-center mb-3">
      <strong>select organization</strong>
    </h1>
    <template v-if="organizations.length">
      <div
        v-for="organization in organizations"
        :key="organization.id"
      >
        <b-card
          :class="{'bg-success':organization.id===orgId}"
          class="cursor-pointer"
          @click="setOrg(organization.id,organization.name)"
        >
          <b-row align-v="center">
            <b-col>
              <b-avatar
                :src="organization.image? organization.image.url : ''"
                size="100"
                class="mr-1"
              >
                <span v-if="!organization.name">Org Image</span>
              </b-avatar>
              {{ organization.name }}
              <span
                v-if="organization.ownedByCurrentUser"
                class="font-weight-bolder ml-1"
              >
                Default
              </span>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </template>
  </div>
</template>

<script>
import Users from '@/compositions/TeamManagement/Users/UsersAPI'
import auth from '@/compositions/Auth/auth'
import handleAlerts from '@/compositions/common/handleAlerts'
import Permissions from '@/compositions/TeamManagement/Permissions/PermissionsAPI'
import { initialAbility } from '@/libs/acl/config'

export default {
  name: 'OrganizationSwitch',
  data() {
    return {
      organizations: [],
    }
  },
  computed: {
    orgId() {
      return Number(this.$store.getters['organization/getOrganizationId'])
    },
  },
  setup() {
    const { indexRequest } = Permissions()
    const { successfulOperationAlert } = handleAlerts()
    const { setOrganization } = auth()
    const { indexOrganizationsRequest } = Users()
    return {
      indexRequest, setOrganization, indexOrganizationsRequest, successfulOperationAlert,
    }
  },
  created() {
    this.getUserOrganizations()
  },
  methods: {
    getUserOrganizations() {
      this.indexOrganizationsRequest(this.$auth.id, { isActive: true }).then(res => {
        this.organizations = res.data.data
      })
    },
    setOrg(id, name) {
      if (id !== this.orgId) {
        this.setOrganization(id, name)
        this.setUserPermissionsInOrg(id)
        this.successfulOperationAlert(`You have switched to "${name}" Organization`)
      }
      this.$router.push({ name: 'organization-profile', query: { firstTabIndex: 1 } })
    },
    setUserPermissionsInOrg(orgId) {
      this.indexRequest(this.$auth.id, orgId).then(res => {
        const permissions = res.data.data.map(group => group.permissions).flat()
        localStorage.setItem('permissions', JSON.stringify(permissions))
        this.$ability.update([...permissions, ...initialAbility])
      })
    },
  },
}
</script>

<style>

</style>
